import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const colourThemeType = PropTypes.shape({
  textColour: PropTypes.string,
  backgroundColour: PropTypes.string,
  linkHover: PropTypes.string,
  buttonHover: PropTypes.shape({
    backgroundColour: PropTypes.string,
    textColour: PropTypes.string,
  }),
});
